import type { FormFieldProps } from 'comp/screenBuilder/comp/formBuilder/types/formPropsTypes';
import React from 'react';
import styled from 'styled-components/macro';
import { Form, Input as AntdInput } from 'antd';
import { FormattedMessage } from 'react-intl';

function Default({ field, formFieldName, removeFormItemLabel }: FormFieldProps): JSX.Element {
  const { formItem, formInput } = field;
  const { label, ...formItemProps } = formItem;

  return (
    <Form.Item
      label={!removeFormItemLabel && label && <FormattedMessage {...label} />}
      {...formItemProps}
      name={formFieldName}
    >
      <Input {...formInput} type='text' />
    </Form.Item>
  );
}

export default Default;

const Input = styled(AntdInput)`
  width: 100%;
  min-width: 100px;
`;
